// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"3fe6bdf4","503":"741f536c","710":"2f7b41a0","911":"a9725ef9"}[chunkId] + ".chunk.js";
};